import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import OrderViewInformationSection from './OrderViewInformationSection';
import OrderViewInformationSectionTitle from './OrderViewInformationSectionTitle';

const styles = () => ({
  listItem: {
    padding: 0,
    display: 'block',
    marginTop: 20,
  },
  gridItem: {
    display: 'flex',
  },
});
const OrderViewInformationVitals = ({
  Vitals,
  classes,
}) => (
  <OrderViewInformationSection>
    <OrderViewInformationSectionTitle>
      Vitals
    </OrderViewInformationSectionTitle>
    <List disablePadding>
      {Vitals.map(vitalsItem => (
        <ListItem
          key={vitalsItem.ID}
          className={classes.listItem}
          disableGutters
        >
          <Grid
            container
            justify="flex-start"
            spacing={24}
          >
            <Grid
              className={classes.gridItem}
              item
            >
              <Typography
                component="span"
                color="secondary"
              >
                W
              </Typography>
              {'\u00A0'}
              <Typography
                component="span"
              >
                {vitalsItem.Weight}{'\u00A0'}lb
              </Typography>
            </Grid>
            <Grid
              className={classes.gridItem}
              item
            >
              <Typography
                component="span"
                color="secondary"
              >
                H
              </Typography>
              {'\u00A0'}
              <Typography
                component="span"
              >
                {vitalsItem['Height Ft']}ft
                {vitalsItem['Height In'] > 0 && (
                  `,\u00A0${vitalsItem['Height In']}in`
                )}
              </Typography>
            </Grid>
            <Grid
              className={classes.gridItem}
              item
            >
              <Typography
                component="span"
                color="secondary"
              >
                BMI
              </Typography>
              {'\u00A0'}
              <Typography
                component="span"
              >
                {vitalsItem.BMI}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            justify="space-between"
            spacing={8}
          >
            <Grid item>
              <Typography
                component="span"
                variant="caption"
              >
                {vitalsItem['Create At']}
              </Typography>
            </Grid>
          </Grid>
        </ListItem>
      ))}
    </List>
  </OrderViewInformationSection>
);

OrderViewInformationVitals.propTypes = {
  Vitals: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
    BMI: PropTypes.number.isRequired,
    'Create At': PropTypes.string.isRequired,
    'Height Ft': PropTypes.number.isRequired,
    'Height In': PropTypes.number.isRequired,
    Weight: PropTypes.number.isRequired,
  })).isRequired,
  classes: PropTypes.shape({
    listItem: PropTypes.string.isRequired,
    gridItem: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(OrderViewInformationVitals);



// WEBPACK FOOTER //
// ./src/components/workflow/OrderViewInformation/OrderViewInformationVitals.js